import React from 'react';

const counterData = [
  {
    icon: 'fas fa-thumbs-up',
    title: 'Completed Projects',
    count: 456,
    delay: '0.2s',
  },
  {
    icon: 'fas fa-users',
    title: 'Happy Customers',
    count: 513,
    delay: '0.4s',
  },
  {
    icon: 'fas fa-user',
    title: 'Qualified Engineers',
    count: 53,
    delay: '0.6s',
  },
  {
    icon: 'fas fa-heart',
    title: 'Years Experience',
    count: 17,
    delay: '0.8s',
  },
];

const FactCounter = () => {
  return (
    <div className="container-fluid counter py-5">
      <div className="container py-5">
        <div className="row g-4">
          {counterData.map((item, index) => (
            <div
              className="col-lg-6 col-xl-3 wow fadeInUp"
              data-wow-delay={item.delay}
              key={index}
            >
              <div className="counter-box">
                <div className="counter-item">
                  <div className="counter-item-style"></div>
                  <div className="counter-item-inner p-5 text-center">
                    <i className={`${item.icon} fa-4x text-secondary`}></i>
                    <h4 className="text-dark my-4">{item.title}</h4>
                    <div className="counter-counting">
                      <span
                        className="text-secondary fs-2 fw-bold"
                        data-toggle="counter-up"
                      >
                        {item.count}
                      </span>
                      <span className="h1 fw-bold text-secondary">+</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div
            className="col-12 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.9s"
          >
            <a className="counter-btn btn btn-secondary py-3 px-5" href="#">
              Join With Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactCounter;
